import { render, staticRenderFns } from "./schoolEdit.vue?vue&type=template&id=47de8847&scoped=true&"
import script from "./schoolEdit.vue?vue&type=script&lang=ts&"
export * from "./schoolEdit.vue?vue&type=script&lang=ts&"
import style0 from "./schoolEdit.vue?vue&type=style&index=0&id=47de8847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47de8847",
  null
  
)

export default component.exports